import React from 'react';

import { StatusPill, StatusPillVariantType } from '@common/components';
import { DisputeStateType } from '@common/graphql';

// NOTE: StatusPill semantics — a redirected dispute is waiting on the other
// party, so it is warning rather than action-needed-here.
const DISPUTE_PILL_VARIANT_MAP: Record<
  DisputeStateType,
  StatusPillVariantType
> = {
  open: 'inProgress',
  rejected: 'danger',
  retracted: 'neutral',
  approved: 'success',
  resolved: 'success',
  archived: 'neutral',
  redirected: 'warning',
};

export const DISPUTE_LABEL_OVERWRITE: Record<DisputeStateType, string> = {
  open: 'Open',
  rejected: 'Rejected',
  retracted: 'Retracted',
  approved: 'Approved',
  resolved: 'Resolved',
  archived: 'Archived',
  redirected: 'Open',
};

const disputeStateLabel = (
  updatedBy: string | undefined
): Record<DisputeStateType, string> => ({
  ...DISPUTE_LABEL_OVERWRITE,
  redirected: `Open, Sent to ${updatedBy}`,
});

export const DisputeState = ({
  state,
  createdBy,
}: {
  state: DisputeStateType;
  createdBy?: 'Supplier' | 'Organization' | undefined;
}) => (
  <StatusPill variant={DISPUTE_PILL_VARIANT_MAP[state]}>
    {disputeStateLabel(createdBy)[state] || state}
  </StatusPill>
);
